export const breakpoints = {
  base: '0px',
  sm: '320px',
  md: '1000px',
  lg: '960px',
  xl: '1200px',
  '2xl': '1536px',
};
